import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UploadAgentSessionAttachmentMutation,
  UploadAgentSessionAttachmentMutationVariables,
} from "./UploadAgentSessionAttachment.generated";

export const UPLOAD_AGENT_SESSION_ATTACHMENT: TypedDocumentNode<
  UploadAgentSessionAttachmentMutation,
  UploadAgentSessionAttachmentMutationVariables
> = gql`
  mutation uploadAgentSessionAttachment(
    $storageObjectName: String!
    $agentSessionUuid: String!
    $fileName: String!
    $contentType: String!
    $managedFileId: String
  ) {
    uploadAgentSessionAttachment(
      storageObjectName: $storageObjectName
      agentSessionUuid: $agentSessionUuid
      fileName: $fileName
      contentType: $contentType
      managedFileId: $managedFileId
    ) {
      ok
      uuid
      fileLink
    }
  }
`;
